import React from "react";
import lock from "../../../../assets/media/icon/lock.svg";
import { useNavigate } from "react-router";
const NewPassword = () => {
  const Nav = useNavigate();
  return (
    <>
      <section className="login-page">
        <div className="login-page-content">
          <div className="login-page-container">
            <h1>Reset password</h1>
            <p>Type your new password !</p>
            <div className="labled-input pb">
              <label>Password</label>
              <div className="iconed-input">
                <div className="icon">
                  <img src={lock} alt="" />
                </div>
                <input type="text" placeholder="********" />
              </div>
            </div>
            <div className="labled-input pb">
              <label>Confirm password</label>
              <div className="iconed-input">
                <div className="icon">
                  <img src={lock} alt="" />
                </div>
                <input type="text" placeholder="********" />
              </div>
            </div>
            <button className="primary-btn reset-btn">Reset password</button>
          </div>
        </div>
      </section>
    </>
  );
};
export default NewPassword;
